import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { hasPermission } from "@/lib/permissions";

export default function ProtectedRoute({ children, requirePermission, requireRole }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center" data-testid="auth-loading">
        <div className="flex flex-col items-center gap-4">
          <div className="h-10 w-10 rounded-full border-2 border-lifted-green/30 border-t-lifted-green animate-spin" />
          <div className="font-bebas tracking-[0.3em] text-lifted-dim text-xs">LOADING ECOSYSTEM…</div>
        </div>
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  if (requirePermission && !hasPermission(user.permissions, requirePermission)) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center p-8">
        <div className="glass-panel p-10 max-w-lg text-center">
          <div className="eyebrow mb-3">Access denied</div>
          <h2 className="font-anton text-3xl mb-3">You don't have access to this area</h2>
          <p className="text-lifted-dim">Required permission: <code className="text-lifted-green">{requirePermission}</code></p>
        </div>
      </div>
    );
  }
  if (requireRole && !user.roles.includes(requireRole) && !user.roles.includes("master_admin")) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center p-8">
        <div className="glass-panel p-10 max-w-lg text-center">
          <div className="eyebrow mb-3">Access denied</div>
          <h2 className="font-anton text-3xl mb-3">Role required</h2>
          <p className="text-lifted-dim">Required role: <code className="text-lifted-green">{requireRole}</code></p>
        </div>
      </div>
    );
  }

  return children;
}
